import React, { useContext } from "react";
//import "./App.css";
import Home from "./Components/Home/Home";
import MainHeader from "./Components/MainHeader/MainHeader";
import Login from "./Components/Login/Login";
import AuthContext from "./store/auth-context";

function App() {
  const ctx = useContext(AuthContext);
  return (
    <React.Fragment>
      <MainHeader />
      <main>
        {!ctx.isLoggedIn && <Login />}
        {ctx.isLoggedIn && <Home />}
      </main>
      <footer style={{ color: "white", textAlign: "center", padding: "1rem", marginTop: "2rem", fontSize: "0.8rem" }}>
        made with ❤️ by Volker Remensperger - BCM Solutions GmbH - 2026
      </footer>
    </React.Fragment>
  );
}

export default App;
